<template>
  <div class=" px-4 justify-center  w-full">
    <div class="justify-center flex mb-4 min-w-[300px]  max-w-[300px]">
      <span class="text-sm" v-html="value.message"></span>
    </div>
    <div class="w-full flex gap-2 mb-2">
      <button class="bg-trader-blue text-white w-full rounded p-2 mt-2" @click="deleteTrue" data-ui="button-confirm-save-ok">ok</button>
    </div>
  </div>
</template>

<script>

import apolloClient from "@/apolloClient";
import {gql} from "@apollo/client/core";
import SignalBus from "@/application/SignalBus";
import {eventBus} from "@/application/EventBus.js";

export default {
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
    }
  },
  methods: {
    deleteTrue(){
      eventBus.closeModal();

      try {
        if(this.value.onAccept){
          this.value.onAccept();
        }
      } catch (e) {}

    },
    deleteFalse(){
      eventBus.closeModal();

      try {
        if(this.value.onCancel){
          this.value.onCancel();
        }
      } catch (e) {}


    }
  },


}


</script>

